// Description: This is the page that is displayed when
// the user tries to access a page that does not exist

// Import libraries
import React from "react";

export default function NoPage() {
    return <div style={{ color: "#FF0000", textAlign: "center" }}>Error 404: Page not found</div>;
}
